import styled from 'styled-components';
import Control from '@widgets/shared/components/NumberInput/styles/control';
export const Price = styled.span `
  display: block;
  text-align: center;
`;
export const Wrapper = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex: 0 1 0;

  ${({ theme: { attendeeWrapper } }) => attendeeWrapper}

  ${Control.Element} {
    ${({ theme: { attendeeTitle } }) => attendeeTitle}
    ${({ theme: { attendeesInput } }) => attendeesInput}
  }
  
  ${Price}{
    ${({ theme: { attendeeCopy } }) => attendeeCopy}
  }
`;
export default {
    Wrapper,
    Price,
};
